import { MarkdownContent } from "features/ui/MarkdownContent";

import ExpandedDirective from "./ExpandedDirective";
import { useHumanMessageContent } from "./HumanMessageContent.hooks";
import MessageDirectivePill from "./MessageDirectivePill";

interface Props {
  content: string;
}

const HumanMessageContent = ({ content }: Props) => {
  const { expandedIndexes, hasDirectives, segments, toggleSegment } =
    useHumanMessageContent(content);

  return (
    <>
      {segments.map((segment, index) => {
        const key = `${index}-${segment.type}`;

        if (segment.type === "text") {
          // A collapsed pill reads as part of the sentence around it, so the
          // message's own paragraphs collapse to inline runs beside it. A
          // message without directives keeps full block Markdown.
          return hasDirectives ? (
            <span key={key} className="[&_p]:inline">
              <MarkdownContent content={segment.text} />
            </span>
          ) : (
            <MarkdownContent key={key} content={segment.text} />
          );
        }

        if (segment.content && expandedIndexes.has(index)) {
          return (
            <ExpandedDirective
              key={key}
              content={segment.content}
              name={segment.name}
              onCollapse={() => toggleSegment(index)}
            />
          );
        }

        return (
          <MessageDirectivePill
            key={key}
            name={segment.name}
            onToggle={segment.content ? () => toggleSegment(index) : undefined}
          />
        );
      })}
    </>
  );
};

export default HumanMessageContent;
